import React from 'react';
import styled from 'styled-components';
// components
import TicketsListContainer from 'modules/emergencies/components/ui/containers/ticketsListContainer';
import BasicLoader from 'modules/emergencies/components/ui/loaders/basicLoader';
import FilterViewsListTable from './filterViewsListTable/filterViewsListTable';

const FilterViewsList = ({ filterViewsListData, className }) => {
  return (
    <TicketsListContainer className={className}>
      {filterViewsListData.isLoadingFilterViews ? (
        <BasicLoader />
      ) : (
        <FilterViewsListTable filterViewsListData={filterViewsListData} />
      )}
    </TicketsListContainer>
  );
};

export default styled(FilterViewsList)``;
